import { inkA, orange, tokens } from 'components/v3';

// Colours inside the in-app fill. The fill has its own dark/light switch, so
// PreviewModal renders it under a nested ThemeProvider whose `name` is the
// preview theme; everything here (and the FormFields inputs, which read
// `theme.name`) follows that, not the admin's theme. Values map the design's
// --ph-* phone tokens onto the v3 palette.
export const ERROR_RED = '#ED4337';

export const phone = (theme) => {
  const t = tokens(theme);
  const dark = !!theme && theme.name === 'dark';
  return {
    accent: t.primary,
    screen: t.page,
    chrome: dark ? t.head : t.card,
    text: t.text,
    text2: inkA(theme, 0.7),
    text3: inkA(theme, dark ? 0.5 : 0.55),
    label: inkA(theme, dark ? 0.9 : 0.85),
    surface: dark ? inkA(theme, 0.05) : t.card,
    border: inkA(theme, dark ? 0.1 : 0.16),
    border2: inkA(theme, dark ? 0.08 : 0.09),
    borderStrong: inkA(theme, 0.3),
    dash: inkA(theme, 0.22),
    accentSoft: orange(0.12),
    accentTint: orange(0.14),
    error: ERROR_RED,
    // Attention card (amber) and success (green) from the design.
    warnBg: 'rgba(245, 158, 11, 0.12)',
    warnBorder: 'rgba(245, 158, 11, 0.45)',
    warnText: dark ? 'rgb(245, 158, 11)' : 'rgb(180, 83, 9)',
    successBg: 'rgba(34, 197, 94, 0.15)',
    successText: dark ? 'rgb(34, 197, 94)' : 'rgb(21, 128, 61)',
  };
};
